import axios from 'axios'
import appconst from './appconst'
import Vue from 'vue'
import Oidc from 'oidc-client'
import tokenCofig from '@/lib/tokenCofig'
import qs from 'qs'

const ajax = axios.create({
    baseURL: appconst.remoteServiceBaseUrl,
    timeout: 30000
});
ajax.interceptors.request.use(function (config) {
    if (localStorage.getItem('access_token')) {
        config.headers.common["Authorization"] = "Bearer " + localStorage.getItem('access_token');
    }
    config.headers.common["Access-Control-Allow-Credentials"] = "true";
    config.headers.common["Accept-Language"] = "zh-hans";
    config.headers.common[".AspNetCore.Culture"] = window.abp.utils.getCookieValue("Abp.Localization.CultureName");
    // config.headers.common["Abp.TenantId"] = window.abp.multiTenancy.getTenantIdCookie();
    if (config.method === 'get' || config.method === 'delete') {
        // 如果是get请求，且params是数组类型如arr=[1,2]，则转换成arr=1&arr=2
        config.paramsSerializer = function (params) {
            return qs.stringify(params, { arrayFormat: 'repeat' });
        }
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});
let vm = new Vue({});
ajax.interceptors.response.use((respon) => {
    return respon
}, (error) => {
    setTimeout(() => {
        vm.$Message.destroy();
    }, 1000);
    if (!!error.response && error.response.status == 204) {
        error.response.status = 200
        return Promise.resolve(error);
    } else if (!!error.response && error.response.status == 401) {
        // token 过期
        localStorage.removeItem('access_token')
        Object.keys(localStorage).forEach(item => item.indexOf('oidc.') != -1 ? localStorage.removeItem(item) : '')
        Object.keys(sessionStorage).forEach(item => item.indexOf('oidc.') != -1 ? sessionStorage.removeItem(item) : '')
        const mgr = new Oidc.UserManager(tokenCofig)
        mgr.signoutRedirect({ id_token_hint: localStorage.getItem('id_token') })
        localStorage.removeItem('id_token')
    } else if (!!error.response && !!error.response.data.error && !!error.response.data.error.message && error.response.data.error.details) {
        vm.$Notice.error({ title: error.response.data.error.message, desc: error.response.data.error.details })
    } else if (!!error.response && !!error.response.data.error && !!error.response.data.error.message) {
        vm.$Notice.error({ desc: error.response.data.error.message })
    } else if (!error.response) {
        vm.$Notice.error({ desc: window.abp.localization.localize('UnknownError') })
    } else {
        vm.$Notice.error({ desc: '请求失败，请稍后再试' })
    }
    return Promise.reject(error);
})
export default ajax;